import { render } from "./AppSidebarComponent.vue?vue&type=template&id=3bf9086c"
import script from "./AppSidebarComponent.vue?vue&type=script&lang=js"
export * from "./AppSidebarComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__